import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <>
      <footer>
        <div className="container">
          <div className="footer__header">
            <span className="footer__logo__text">SIMO</span>
          </div>
          {/* <div className="footer__links">
            <ul>
              <li>
                <a href="/">About</a>
                <a href="/">Case Studies</a>
                <a href="/">FAQs</a>
                <a href="/">Contact</a>
              </li>
            </ul>
          </div> */}
          <div className="footer__media">
            <ul>
              <li>
                <a href="/">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 3.5H7.5C4.5 3.5 2.5 5 2.5 8.5V15.5C2.5 19 4.5 20.5 7.5 20.5H17.5C20.5 20.5 22.5 19 22.5 15.5V8.5C22.5 5 20.5 3.5 17.5 3.5ZM17.97 9.59L14.84 12.09C14.18 12.62 13.34 12.88 12.5 12.88C11.66 12.88 10.81 12.62 10.16 12.09L7.03 9.59C6.71 9.33 6.66 8.85 6.91 8.53C7.17 8.21 7.64 8.15 7.96 8.41L11.09 10.91C11.85 11.52 13.14 11.52 13.9 10.91L17.03 8.41C17.35 8.15 17.83 8.2 18.08 8.53C18.34 8.85 18.29 9.33 17.97 9.59Z"
                      fill="white"
                    />
                  </svg>
                  manu@simosoftware.com
                </a>
              </li>
              {/* <li>
                <a href="/">
                  <svg
                    width="17"
                    height="14"
                    viewBox="0 0 17 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.862 3.66301C14.8717 3.80766 14.8717 3.95232 14.8717 4.09831C14.8717 8.54664 11.5697 13.6769 5.53173 13.6769V13.6743C3.7481 13.6769 2.00152 13.153 0.5 12.165C0.759354 12.197 1.02001 12.213 1.28131 12.2137C2.75944 12.215 4.19531 11.7064 5.35818 10.7698C3.9535 10.7425 2.72173 9.80321 2.29143 8.43198C2.78349 8.52931 3.29049 8.50931 3.77345 8.37399C2.24203 8.05668 1.14026 6.67678 1.14026 5.07424C1.14026 5.05957 1.14026 5.04557 1.14026 5.03157C1.59657 5.29222 2.10748 5.43687 2.63008 5.45287C1.18771 4.46428 0.743104 2.49643 1.61412 0.957879C3.28074 3.06105 5.73973 4.33962 8.37942 4.47495C8.11487 3.3057 8.47627 2.08046 9.32909 1.25852C10.6512 -0.016048 12.7306 0.0492805 13.9734 1.40451C14.7086 1.25586 15.4132 0.97921 16.058 0.58724C15.8129 1.36651 15.3001 2.02846 14.615 2.4491C15.2656 2.37044 15.9013 2.19179 16.5 1.91914C16.0593 2.59642 15.5042 3.18638 14.862 3.66301Z"
                      fill="white"
                    />
                  </svg>
                  Twitter
                </a>
              </li> */}
              {/* <li>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_2118_1183)">
                    <path
                      d="M16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 11.993 3.42548 15.3027 7.25 15.9028V10.3125H5.21875V8H7.25V6.2375C7.25 4.2325 8.44434 3.125 10.2717 3.125C11.147 3.125 12.0625 3.28125 12.0625 3.28125V5.25H11.0537C10.0599 5.25 9.75 5.86667 9.75 6.49933V8H11.9688L11.6141 10.3125H9.75V15.9028C13.5745 15.3027 16.5 11.993 16.5 8Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2118_1183">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <a href="/">Facebook</a>
              </li> */}
              <li>
                <a href="/">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.7621 13.6331H14.1328L14.1338 9.44479C14.1338 7.38865 13.6907 5.80815 11.2879 5.80815C10.3694 5.77405 9.5065 6.24796 9.04244 7.04144H9.01058V5.99806H6.73471V13.6329H9.10541V9.85596C9.10541 8.86 9.29433 7.8954 10.5291 7.8954C11.7463 7.8954 11.7621 9.03509 11.7621 9.92042V13.6331Z"
                      fill="white"
                    />
                    <path
                      d="M2.68378 3.5789C2.68391 4.33872 3.29997 4.95457 4.05977 4.95443C4.42464 4.95437 4.77454 4.80936 5.0325 4.5513C5.29045 4.29325 5.43534 3.94329 5.43527 3.57841C5.43513 2.81859 4.81908 2.20274 4.05928 2.20288C3.29947 2.20302 2.68364 2.81908 2.68378 3.5789Z"
                      fill="white"
                    />
                    <path
                      d="M2.87195 13.6331H5.24512V5.99806H2.87195V13.6331Z"
                      fill="white"
                    />
                  </svg>
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
          <div className="footer__copyright">
            <p>© 2025 SIMO. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
